import { LastArticlesSliderAdapter } from "@features/articles/components/LastArticlesSliderAdapter";
import styled from "styled-components";

export const StyledArticlesAndCompanyNewsSection = styled(
  LastArticlesSliderAdapter
)``;
